import { Language } from "../languages/labels/language.labels";
import { GlobalSwal } from "../styles/swal.style";
import { errors } from "../languages/translations/errors";
import { toastError } from "../utils/toast.util";

// ---------------------------------------------------------------------------
// Throttle: multiple simultaneous failures → single toast
// ---------------------------------------------------------------------------

let lastNetworkToastAt = 0
const THROTTLE_MS = 3000

function isThrottled(): boolean {
  const now = Date.now()
  if (now - lastNetworkToastAt < THROTTLE_MS) return true
  lastNetworkToastAt = now
  return false
}

/** True for 5xx gateway errors that already went through retries. */
function isGatewayError(status: number | undefined): boolean {
  return status === 502 || status === 503 || status === 504
}

export function errorWebHandler(lang: Language, error: any) {
  if (error.response) {
    if (isGatewayError(error.response.status)) {
      // Gateway errors (after retries exhausted) → non-blocking toast
      if (!isThrottled()) {
        const requestId = error.response.headers?.['x-amzn-requestid']
        const detail = requestId ? ` (ref: ${requestId})` : ''
        console.warn(`[network] ${error.response.status} on ${error.config?.url}${detail}`)
        toastError(lang.labels.serviceTemporarilyUnavailable)
      }
    } else {
      // Other HTTP errors (400, 401, 404, 422…) → modal as before
      GlobalSwal.fire({
        title: lang.labels.httpError,
        text: (errors.find((item) => (item.code === error.response.status))?.[lang.code as keyof typeof errors[0]]) || error.response.data?.message || lang.labels.serverErrorOccurred,
        icon: "error",
        confirmButtonText: lang.labels.okGotIt
      })
    }
  } else if (error.request) {
    // Network error (no response at all, after retries exhausted) → non-blocking toast
    if (!isThrottled()) {
      console.warn(`[network] No response on ${error.config?.url}: ${error.message}`)
      toastError(lang.labels.serviceTemporarilyUnavailable)
    }
  } else if (error.message) {
    GlobalSwal.fire({
      title: lang.labels.exclamError,
      text: error.message,
      icon: "error",
      confirmButtonText: lang.labels.okGotIt
    })
  } else {
    window.location.href = '/error'
  }
}
